import { AlertOutlined, FileTextOutlined, FolderOpenOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { OfferDocumentTypeDto } from 'src/dtos';

export interface OfferDocumentIconProps {
  type: OfferDocumentTypeDto;
  className?: string;
}

export const OfferDocumentIcon = ({ type, className }: OfferDocumentIconProps) => {
  switch (type) {
    case 'investor_presentation':
      return <PlayCircleOutlined className={className} />;
    case 'offering_summary':
      return <FileTextOutlined className={className} />;
    case 'offering_document':
      return <FolderOpenOutlined className={className} />;
    case 'risk_factors':
      return <AlertOutlined className={className} />;
    case 'subscription_agreement':
      return <FileTextOutlined className={className} />;
    case 'circular_offering_document':
      return <FileTextOutlined className={className} />;
    default:
      return null;
  }
};
